/** Redirect the browser to the Abacate hosted checkout. Isolated so it can be mocked. */
export function redirectToCheckout(url: string) {
  window.location.href = url
}
